export default __webpack_public_path__ + "static/media/5989 - Vandy.ed4d0b67.jpeg";